module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 317
// module chunks = 0